import type React from 'react';
import { StyledDivider } from './divider.styles';

export default function Divider({ noMargin }: { noMargin?: boolean }) {
  return <StyledDivider noMargin={noMargin} />;
}
